export const GET_PLAYER_SELECT_LIST = 'GET_PLAYER_SELECT_LIST';
export const GET_PLAYER_SELECT_LIST_SUCCESS =
    'GET_PLAYER_SELECT_LIST_SUCCESS';
export const GET_PLAYER_SELECT_LIST_FAIL = 'GET_PLAYER_SELECT_LIST_FAIL';
